export default __webpack_public_path__ + "assets/images/6.e7c933.png";